/** Faixa estática do checkout antigo. Não conta tempo: um cronômetro que reinicia a cada visita seria urgência falsa. */
function AlarmIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07a7.001 7.001 0 0 1 3.274 12.44l.601.602a.5.5 0 0 1-.707.708l-.746-.746A6.97 6.97 0 0 1 8 16a6.97 6.97 0 0 1-3.422-.892l-.746.746a.5.5 0 0 1-.707-.708l.602-.602A7.001 7.001 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5m2.5 5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9zM.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.04 8.04 0 0 0 .86 5.387M11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.04 8.04 0 0 0-3.527-3.527" />
    </svg>
  );
}

export function LegacyCountdown({ label }: { label: string }) {
  return (
    <div className="vp-legacy-timer">
      <span className="vp-legacy-timer-icon" aria-hidden="true">
        <AlarmIcon />
      </span>
      <span className="vp-legacy-timer-label">{label}</span>
    </div>
  );
}
